import { OptionType } from '@insurancemenu/imenu-components-lib/dist/types';
import { RateSegment } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { makeAutoObservable, runInAction } from 'mobx';
import { INITIAL_CART_OBJECT } from 'store/domain/cartStoreV2';
import { RootStore } from 'store/rootStore';
import { Cart } from 'types/cartServiceV2';
import { BcInfo } from 'types/general';

export default class TemplatesModalStore {
  rootStore: RootStore;
  loading = false;
  showTemplatesModal = false;
  templates: Cart[] = [];
  rateSegment: RateSegment = 'GROUP';

  setLoading(loadingStatus: boolean): void {
    this.loading = loadingStatus;
  }

  async openTemplatesModal(rateSegment: RateSegment, bc: BcInfo): Promise<void> {
    this.showTemplatesModal = true;
    this.rateSegment = rateSegment;
    await this.getBrokerCarts(rateSegment, bc);
  }

  closeTemplatesModal(): void {
    this.showTemplatesModal = false;
  }

  public async getBrokerCarts(rateSegment: RateSegment, bc: BcInfo): Promise<void> {
    this.setLoading(true);

    const res = await this.rootStore.cartStoreV2.getBrokerCartsByRateSegment(rateSegment, bc);
    runInAction(() => {
      this.templates = res.data?.getBrokerCartsBySegment || [];
      this.setLoading(false);
    });
  }

  public getTemplatesOptions(): OptionType[] {
    return this.templates.map(({ id, cartName }) => {
      return { value: id, label: cartName };
    });
  }

  async applyBrokerCart(cartId: string, bc: { [key: string]: string }, groupId: string): Promise<Cart> {
    this.setLoading(true);

    const res = await this.rootStore.cartStoreV2.applyBrokerCart(cartId, bc, groupId);
    runInAction(() => {
      this.setLoading(false);
    });
    return res.data?.applyBrokerCart || INITIAL_CART_OBJECT;
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
